import { render, staticRenderFns } from "./SupplierUserList.vue?vue&type=template&id=1229809f&scoped=true&"
import script from "./SupplierUserList.vue?vue&type=script&lang=js&"
export * from "./SupplierUserList.vue?vue&type=script&lang=js&"
import style0 from "./SupplierUserList.vue?vue&type=style&index=0&id=1229809f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1229809f",
  null
  
)

export default component.exports